import axios from 'axios';

export const GetPipelineOptions = async () => {
    const uri = 'api/crmSharedFront/getPipelineOptions';

    return await getOptionsFromUri(uri);
};

export const GetLabelOptions = async () => {
    const uri = 'api/crmSharedFront/getLabelOptions';

    const response = await getOptionsFromUri(uri);

    return response;
};

export const GetRoleOptions = async () => {
    const uri = 'api/crmSharedFront/getRoleOptions';

    const response = await getOptionsFromUri(uri);

    return response;
};

export const GetSkillOptions = async () => {
    const uri = 'api/crmSharedFront/getSkillOptions';

    const response = await getOptionsFromUri(uri);

    return response;
};

export const GetActivityTypeOptions = async () => {
    const uri = 'api/crmSharedFront/getActivityTypeOptions';

    const response = await getOptionsFromUri(uri);

    return response;
};

export const GetPlaceOptions = async () => {
    const uri = 'api/crmSharedFront/getPlaceOptions';

    const response = await getOptionsFromUri(uri);

    return response;
};

export const GetOfficeOptions = async () => {
    const uri = 'api/crmSharedFront/getOfficeOptions';

    const response = await getOptionsFromUri(uri);

    return response;
};

export const GetCrmUserOptions = async () => {
    const uri = 'api/crmSharedFront/getCrmUserOptions';

    const response = await getOptionsFromUri(uri);

    return response;
};

export const GetBossGroupOptions = async () => {
    const uri = 'api/crmSharedFront/getBossGroupOptions';

    const response = await getOptionsFromUri(uri);

    return response;
};

const getOptionsFromUri = async (uri) => {
    const response = await axios
        .get(uri, {
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json;charset=UTF-8',
            },
        })
        .then((response) => {
            return { success: true, data: response.data };
        })
        .catch((thrown) => {
            return {
                success: false,
                error: thrown.error?.data?.error ?? 'Unknown error',
            };
        });

    return response;
};
